export default {
  dataSource: {
    caps: 1,
    cnc: 2,
    ms: 16,
  },
  typeofContact: {
    primary: 1,
    mailing: 2,
    secondary: 4,
    emergency: 5,
  },
};
